import { Box, Container, Dialog, DialogContent, Typography, useMediaQuery, type Theme } from '@mui/material';
import { useEffect, useState } from 'react';
import { ForgotForm } from './login/ForgotForm';
import { LoginForm } from './login/LoginForm';
import { ResetForm } from './login/ResetForm';
import { Logo } from './Logo';

type CurrentForm = 'login' | 'forgot' | 'sent' | 'reset';

export const Login = () => {
    const [currentForm, setCurrentForm] = useState<CurrentForm>('login');
    const isSm = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

    const handleFormChange = (nextForm: CurrentForm) => {
        setCurrentForm(nextForm);
    };

    useEffect(() => {
        localStorage.removeItem('auwx');

        const url = new URL(window.location.href);
        const token = url.searchParams.get('token');
        const reset = url.searchParams.get('reset');

        if (token && reset === '0') {
            localStorage.setItem('auwx', token);
            setCurrentForm('reset');
        }
    }, []);

    return (
        <Container
            maxWidth={false}
            sx={{
                display: 'flex',
                justifyContent: 'center',
                backgroundImage: 'url("/images/rainOnValley.webp")',
                backgroundSize: 'cover',
                height: '100vh',
            }}>
            <Dialog open={true} fullScreen={isSm} slotProps={{ paper: { sx: { alignSelf: 'flex-start' } } }}>
                <DialogContent sx={{ width: '100%', maxWidth: isSm ? 600 : 500 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                        <Logo width={180} height={120} />
                    </Box>
                    {currentForm === 'login' && <LoginForm onFormChange={handleFormChange} />}
                    {currentForm === 'forgot' && <ForgotForm onFormChange={handleFormChange} />}
                    {currentForm === 'reset' && <ResetForm onFormChange={handleFormChange} />}
                    {currentForm === 'sent' && <Typography variant="body1">Please check your email for a password reset link. The reset link is only vaild for a limited time.</Typography>}
                </DialogContent>
            </Dialog>
        </Container>
    );
};
